import { KolumnaSpisuFiltrowanie } from './kolumnaSpisuFiltrowanie';

export class PobierzSpisaneSrodkiCalegoProjektuFiltry {
  kolumnyFiltrowania: Array<KolumnaSpisuFiltrowanie> = new Array();
  idProjektu: string;
}
